import React from 'react';
import styled from 'styled-components';

import removeImgSrcset from 'utilities/removeImgSrcset';
import Page from 'components/Page';


const TwoColumnTemplate = ({ page: { acf: { content, image, quote_text, quote_author, background_color, quote_color } } }) => {
    return (
        <Page>
            <Inner $backgroundColor={background_color}>
                <Row>
                    <Column>
                        <Content className="content" dangerouslySetInnerHTML={{ __html: removeImgSrcset(content) }} />
                    </Column>

                    <Column>
                        <Image src={image?.sizes?.['2048x2048']} />
                        
                        {quote_text && (
                            <Quote $quoteColor={quote_color}>
                                <QuoteIcon />
                                <QuoteText dangerouslySetInnerHTML={{ __html: quote_text }} />
                                <QuoteAuthor className="h6">&mdash; {quote_author}</QuoteAuthor>
                            </Quote>
                        )}
                    </Column>
                </Row>
            </Inner>
        </Page>
    );
};


export default TwoColumnTemplate;

const Inner = styled.div`
    width: 100%;
    height: 100%;
    padding: 5rem;
    background-color: ${props => props.$backgroundColor};
`;

const Column = styled.div`
    display: flex;
    flex-direction: column;
    gap: 2rem;
`;

const Row = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 14rem;

    ${Column}:first-child {
        width: 50rem;
    }

    ${Column}:last-child {
        width: 82rem;
    }
`;

const Content = styled.div`
    h5 {
        background: ${props => props.theme.gold_gradient};
        background-clip: text;
        color: transparent;
        text-transform: uppercase;
    }
`;

const Image = styled.img`
    width: 100%;
    height: auto;
`;

const Quote = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 2rem;
    padding: 4rem;
    text-align: center;
    color: ${props => props.theme.primary_color};
    background-color: ${props => props.$quoteColor};
`;

const QuoteText = styled.div`
    width: 44rem;
`;

const QuoteAuthor = styled.div`
`;

const QuoteIcon = styled.div`
    font-size: 6rem;
    line-height: 0; 
    font-weight: 700;
    opacity: .3;
    &::before {
        content: '\\201c';
        display: inline-block;
        vertical-align: text-bottom;
    }
`;